import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: "codigoBarrasPipe" })
export class CodigoBarrasPipe implements PipeTransform {
  transform(codigo: string): string {
    return codigo?.replace(/(\d{11})(\d{11})(\d{11})(\d{11})/, '$1 $2 $3 $4') ?? "";
  }
}
